import React, { useState, useEffect } from "react";
// import "./CheckWarranty.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/api/API";
import CustomTable from "../../../customComponents/CustomTable";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import viewIcon from "../../../../Assets/icons/ClaimIcon.svg";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";
import DownloadSVG from "../../../../Assets/icons/DownloadIconMIS.svg";
import DetailsTable from "../../Admin/OrderManagement/CustomOrderTable/CustomOrderTable";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import { IoMdClose } from 'react-icons/io';
import searchIcon from '../../../../Assets/icons/searchicon.svg';

const DealerLoginReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});

  const [filters, setFilters] = useState({});
  const [vinNoData, setVinNoData] = useState([]);
  // const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [dealerOption, setDealerOptions] = useState([]);

  const navigate = useNavigate();
  // const token = localStorage.getItem("authToken");
  const token = sessionStorage.getItem("u_t");
  const dealerId = localStorage.getItem("dealerId");
  localStorage.removeItem("JobCardComplainData");

  useEffect(() => {
    fetchLoginHistory();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchLoginHistory(newPage);
  };

  const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  

  const fetchLoginHistory = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const payload = {
      page,
      pageSize,
      searchText: searchTerm,
      orderBy: "loginHistoryId desc",
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
      fromDate: formatDateToDDMMYYYY(allfilteredData?.fromDate),
      toDate: formatDateToDDMMYYYY(allfilteredData?.toDate),
      dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
    };
    console.log("filteresdata", payload);

    try {
      // setTableLoader(true)
      const response = await axiosInstance.post("/login-history", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data.map((item, index) => ({
        ...item,
        item_name: item.item_name || "--",
        model_name: item.model_name || "--",
        variant_name: item.variant_name || "--",
        logInDateTime: item.logInDateTime
          ? new Date(item.logInDateTime)
              .toLocaleString("en-GB", { hour12: false }) // 24-hour format
              .replace(/\//g, "-") // Convert date separator to "-"
          : "--",
      }));
      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      setVinNoData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };
  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("add-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate("job-card-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "UserName",
    "UserType",
    // "LoginUserId",
    "LoginUserIp",
    "Message",
    "Action Type",
    "Login Date Time",
    // "Total Vehicle",
    // "Total Spare Parts",
    // "Total Accessories",
    // "Action"
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    UserName: "user_name",
    UserType: "userType",
    LoginUserId: "loginUserId",
    "Login Date Time": "logInDateTime",
    LoginUserIp: "loginUserIp",
    "Total Vehicle": "total_vehicle",
    "Total Spare Parts": "total_sparepart",
    "Total Accessories": "total_accessories",
    "Vin No.": "dealer_name",
    Message: "message",
    "Action Type": "actionType",
    Days: "remaining_days",
    "Warranty From": "warrantyFrom",
    "Warranty To": "warrantyTo",
    Action: [{ type: "claim", icon: viewIcon, label: "claim" }],
  };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
    fetchLoginHistory();
  }, [filters]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchLoginHistory();
    }
  }, [searchTerm]);


  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClear = () => {
    setFilterFormData({});
  };
  const handleClaim = () => {
    console.log("clicked");
    navigate(ROUTES_NAVIGATION.ADDJOBCARD);
  };

  const PhysicalStockTakingInputs = [
    {
      name: "dealerId",
      label: "Dealer Name",
      type: "dropdown",
      // required: true,
      options: dealerOption,
      gridClass: "col-lg-3",
    },
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "toDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
  ];

  const handleSearchKey = (e) => {

    const term = e.target.value;
    setSearchTerm(term);
    
   
  };

  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      dealerId: filterFormData.dealerId || null,
    });
  };
  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchLoginHistory();
    // setSearchTerm("")
  };

  const clearSearch = () => {
    setSearchTerm("")
    fetchLoginHistory()
  }

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};


  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      searchText: "",
      orderBy: "loginHistoryId desc",
      page: 0,
      pageSize: 10,

      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
    };

    try {
      const response = await axiosInstance.post(
        "/login-history-export",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Login_history.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  useEffect(() => {
    fetchDealerOptions()
  },[])

  const fetchDealerOptions = async () => {
    try {
      const response = await axiosInstance.get(
        "/dealer/dealerList",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((dealer) => ({
        label: dealer.user_name,
        value: dealer.user_id,
      }));
      setDealerOptions(options);
    } catch (error) {
      console.error("Error fetching dealer options:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      fetchLoginHistory();
    }
  };

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div
          style={{ width: "100%" }}
          className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2"
        >
          <div
            style={{
              lineHeight: "1px",
              display: "flex",
              flexDirection: "column",
              paddingTop: "30px",
            }}
          >
            <div>
              {/* <p className="ServiceBreadcrumbs" >Home / Report / MIS Report </p> */}
            </div>
            <div>
              <h5
                style={{ fontWeight: "600" }}
                className="checkWarrantyHeading"
              >
                Dealer Login Report
              </h5>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            <img
              onClick={downloadExcel}
              src={DownloadSVG}
              alt="downloadSvg"
              style={{ paddingTop: "33px", cursor: "pointer" }}
            />
            <div></div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          <div className="listSideBorder" />
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView"></div>

        <div style={{ paddingTop: "20px" }}>
          <CustomTable
            data={vinNoData}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            onEdit={handleEdit}
            handleViewButton={handleViewButton}
            itemsPerPage={10}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            handleClaim={handleClaim}
            // isADDcomplainTable="true"
            currentPage={currentPage}
          />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default DealerLoginReport;
